import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=4773af46&scoped=true&"
import script from "./DetailsModal.vue?vue&type=script&lang=js&"
export * from "./DetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4773af46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4773af46')) {
      api.createRecord('4773af46', component.options)
    } else {
      api.reload('4773af46', component.options)
    }
    module.hot.accept("./DetailsModal.vue?vue&type=template&id=4773af46&scoped=true&", function () {
      api.rerender('4773af46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BPMeletronicSigned/modules/DetailsModal.vue"
export default component.exports